<template>
    <div class="row">
        <div class="col-12">
            <div class="pull-left" v-if="filter.year">
                <label style="color: black;">
                    {{valueName}} Давлат кўчмас мулкидан фойдаланилганлиги учун қўлланадаган ижара тўловининг энг кам миқдордаги ставкалари.
                    <br/>{{filter.year}} йил у-н 1 кв.м минимал ставка
                </label>
            </div>

            <router-link tag="button" class="all-btn add-btn pull-right" to="/config/rental-rates/add">
                {{$t("action.add")}}
            </router-link>
        </div>

      <div class="col-12">
        <b-tabs pills>
          <b-tab v-for="(year, index) in years" :key="index" :title="year" @click="setFilterYear(year)">
          </b-tab>
        </b-tabs>
      </div>
<!--        <div class="col-lg-1" v-for="(year, index) in years" :key="index">
            <b-tabs pills>
                <b-tab>
                    <button class="all-btn pull-right" @click="setFilterYear(year)">{{year}}</button>
                </b-tab>
            </b-tabs>
        </div>-->

        <div class="col-12 d-flex flex-wrap">
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(1, 'Андижон вилоятида')">Андижон</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(2, 'Бухоро вилоятида')">Бухоро</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(3, 'Жиззах вилоятида')">Жиззах</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(4, 'Қашқадарё вилоятида')">Қашқадарё</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(14,'Қорақалпоғистон республикасида')">Қорақалпоғистон</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(5, 'Навоий вилоятида')">Навоий</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(6, 'Наманган вилоятида')">Наманган</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(7, 'Самарқанд вилоятида')">Самарқанд</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(9, 'Сирдарё вилоятида')">Сирдарё</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(8, 'Сурхондарё вилоятида')">Сурхондарё</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(10, 'Тошкент вилоятида')">Тошкент</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(13, 'Тошкент шаҳри')">Тошкент шаҳри</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(11, 'Фарғона вилоятида')">Фарғона</button>
            <button class="all-btn add-btn mx-1" @click="getRentalRatesValuesByProvince(12, 'Хоразм вилоятида')">Хоразм</button>
        </div>

        <div class="col-12">
            <div class="container-fluid" style="padding-top: 10px;">
                <template v-if="!loading && results && results.data">
                    <div class="row" style="background-color: #48D1CC;">
                        <div class="col-sm-2 tdBor">Вилоятни</div>
                        <div class="col-sm-3 tdBor">Ижарага бериладиган майдонларнинг умумий номи</div>
                        <div class="col-sm-5 tdBor">Ижарага бериладиган майдонларнинг ижара максадлари бўйича номи</div>
                        <div class="col-sm-1 tdBor">Шаҳар</div>
                        <div class="col-sm-1 tdBor">Шаҳарча ва туманлар</div>

                    </div>
                    <div class="row" v-for="result in results.data" :key="result.id">
                        <div class="col-sm-2 tdBor">{{result.province.name}}</div>
                        <div class="col-sm-3 tdBor">{{result.purposesRentingAreasName}}</div>
                        <div class="col-sm-5 tdBor">{{result.purposesRentingAreasItemName}}</div>
                        <div class="col-sm-1 tdBor">{{result.cityMinimumRates}}</div>
                        <div class="col-sm-1 tdBor">{{result.districtTownMinimumRates}}</div>
                    </div>

                </template>
            </div>

        </div>
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';

    export default {
        name: "RentalRatesList",
        components: {
            bTabs,
            bTab
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                lastId: null,
                mibLetterDate: null,
                valueName: "",
                years: [],
            }
        },
        methods: {
            initYears() {
                const vm = this;
                const promises = [this.$http.get('rental-rates/rental-rates-years-list')];

                Promise.all(promises).then(function (values) {
                    const initData0 = values[0].data;
                    vm.years = initData0.data;

                    console.log(vm.years)

                });
            },

            getRentalRatesValuesByProvince(provinceId, value) {
                if (provinceId != null && this.filter.year!=null) {
                    this.valueName = value;
                    this.filter.provinceId = provinceId;
                    this.loading = true;
                    this.$http.post('rental-rates/list', this.filter)
                        .then(res => {
                            this.results = res.data;
                            console.log(this.results);
                            this.loading = false;
                        }, err => {
                            console.log(err);
                            this.loading = false;
                        });
                }else{
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: 'Yilni tanlang',
                        type: 'warning'
                    });

                }
            },
            setFilterYear(year) {
                this.filter.year = year;
            },
        },
        created() {
            this.initYears();
        }
    }
</script>

<style scoped>
    h3 {
        display: block;
        font-size: 1.17em;
        margin-top: 1em;
        margin-bottom: 1em;
        margin-left: 0;
        margin-right: 0;
        font-weight: bold;
    }

    .colorButton{
      background-color: #97181d;
    }
    .tdBor {
        border: 1px solid black;
    }
</style>